import React, { useEffect } from "react";
import { Box, TextField, Button, Grid } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PostAPI } from "../../Components/Backend/PostAPI";
import {
  formatDateTime,
  usePermiteAcesso,
} from "../../Components/Funcionais/Utils";
import PageTitle from "../../Components/Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import ListIcon from "@mui/icons-material/List";
import GroupsIcon from "@mui/icons-material/Groups";
import InsertLinkIcon from '@mui/icons-material/InsertLink';

const MenuIncluir = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(3); //Cadastro de Menu
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();

  const [formData, setFormData] = useState({
    adm: "N",
    descricao: "",
    grupo: "",
    id: "",
    idEmpresa: "",
    tipo: "link",
    valor: "",
  });

  const handleVoltar = () => {
    navigate("/menu");
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: valor, 
    }));
  };

  // Limpa os campos do formulário após a inclusão, se for incluir mais um registro
  const limparCampos = () => {
    setFormData({
    adm: "",
    descricao: "",
    grupo: "",
    id: 0,
    idEmpresa: "",
    tipo: "",
    valor: "",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);
    const response = await PostAPI(apiAxios, "/menu", formData);

    setLoading(false);

    if (response.success) {
      setFormData(response.data);

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Menu incluído com sucesso!");
      if (modoIncluirMais) {
        limparCampos();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 3000)); // aguarda 3 segundos
        navigate("/menu");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar perfil.");
    }
  };

  return (
    <div>
      {/******************************* TITULO E FUNCIONALIDADES *************************/}
      <PageTitle
        caption="Cadastro de Menu"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/**********************************************************************************/}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          justifyContent: "center",
        }}
      >
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Descrição */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Descrição:"
                variant="outlined"
                value={formData.descricao}
                onChange={(e) => handleChange(e, 50)}
                required
                name="descricao"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Grupo */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Grupo:"
                variant="outlined"
                value={formData.grupo}
                onChange={(e) => handleChange(e, 50)}
                required
                name="grupo"
                placeholder="Ex: Sites, Dasboards, Documentos."
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <GroupsIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Tipo */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Tipo:"
                variant="outlined"
                value={formData.tipo}
                onChange={(e) => handleChange(e, 50)}
                disabled
                name="tipo"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <ListIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Valor */}
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                label="Endereço / Caminho:"
                variant="outlined"
                value={formData.valor}
                onChange={(e) => handleChange(e)}
                required
                name="valor"
                placeholder="Digite ou cole aqui o link de referência"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <InsertLinkIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between", // separa esquerda e direita
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mt: 2,
              }}
            >
              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", width: "100%" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  width: { xs: "100%", md: "auto" },
                  flexDirection: { xs: "column", md: "row" },
                }}
              >
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setModoIncluirMais(true)}
                  type="submit"
                  sx={{
                    borderColor: "#1a3865",
                    color: "#1a3865",
                  }}
                >
                  Salvar + Incluir
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    backgroundColor: "#1a3865",
                  }}
                  onClick={() => setModoIncluirMais(false)}
                  type="submit"
                >
                  Salvar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default MenuIncluir;
